import React from 'react';
import { createPortal } from 'react-dom';
import { Styles } from './styles';

export interface FeedbackModalProps {
  open: boolean;
  variant: 'success' | 'error';
  title: string;
  message: string;
  onClose: () => void;
  buttonLabel?: string;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  open,
  variant,
  title,
  message,
  onClose,
  buttonLabel
}) => {
  if (!open) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  return createPortal(
    <Styles.Overlay onClick={handleOverlayClick} role="dialog" aria-modal>
      <Styles.Card>
        <Styles.Icon variant={variant}>
          {variant === 'success' ? '✓' : '✕'}
        </Styles.Icon>
        <Styles.Title>{title}</Styles.Title>
        <Styles.Message>{message}</Styles.Message>
        <Styles.Button variant={variant} onClick={onClose}>
          {buttonLabel ??
            (variant === 'success' ? 'Fechar' : 'Tentar novamente')}
        </Styles.Button>
      </Styles.Card>
    </Styles.Overlay>,
    document.body
  );
};

export default FeedbackModal;
